export default "__VITE_ASSET__Sq5QndsC__"